import React, { useEffect, useRef, useState } from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "./ListPayroll.config";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  getApproveStatus,
  getPhongBanAPI,
  searchBangLuong,
} from "../../../../../redux/reducer/employee";
import { ColumnProps } from "../../../../../types/models";
import Notification from "../../../../../components/common/notification/notification";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  ModalCustom,
} from "../../../../../components/common";
import "./ListPayroll.scss";
import {
  Button,
  Col,
  Input,
  InputNumber,
  Popover,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import Icons from "../../../../../assets/icons";
import { ExcelSVG, SaveWhiteIconSVG, ZipSVG } from "../../../../../assets";
import { employeeService } from "api";
import axiosClient from "../../../../../api/axiosClient";
import {
  formatNumber,
  generateFileName,
  saveTableOptions,
  generateFileNameZip,
  getTableOptions,
} from "../../../../../helper/common";

import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import PayMentRequest from "./PopupExcel/paymentRequest";
import { APPROVE_STATUS } from "types/enums/employee";
import { setButtonsHeader } from "redux/reducer/common";
import usePermission from "hooks/usePermission";
import ExpandSearchHCNS from "components/common/ExpandSearch/ExpandSearchHCNS";
import { message } from 'antd';

const ListPayroll = () => {
  const { isQuanLy, isGiamDoc, isAdminHCNS } = usePermission();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear(); // Lấy năm hiện tại (ví dụ: 2023)
  const currentMonth = currentDate.getMonth() + 1; // Lấy tháng hiện tại (0 - 11, cần cộng thêm 1 để có giá trị tháng thực tế)
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    nam: currentYear,
    thang: currentMonth,
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const { ApproveStatusList = [] } = useAppSelector(
    (state) => state.employeesReducer
  );
  let savedTableOption = getTableOptions(
    "LISTPAYROLL_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter((e) => e.show == true)
  );
  columns.map((e) => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector((state) => state.employeesReducer);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const modalRef = useRef<any>();
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);

  const onClickSearch = async () => {
    setCurrentPage(1);
    var searchFields = expandRef?.current?.getData();
    setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
  };
  useEffect(() => {
    expandRef?.current.setFieldValue("nam", currentYear);
    expandRef?.current.setFieldValue("thang", currentMonth);
  }, []);
  const getList = async (params) => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(searchBangLuong(params));
    setLoading(false);
  };

  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };
  useEffect(() => {
    getList({
      ...params,
    });
  }, [params]);
  useEffect(() => {
    setData(
      employees.BangLuongList.map((list) => ({
        ...list,
        key: list.id,
        thamGiaBHXH:
          list.thamGiaBHXH === null
            ? null
            : list.thamGiaBHXH === "1"
            ? "1"
            : null,
      }))
    );
  }, [employees.BangLuongList]);
  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "LISTPAYROLL_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const onClickRoll = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
    handleExportZipRoll(params);
  };
  const handleExportZipRoll = async (params) => {
    const url = "hanhchinhnhansu/bang-luong/report";
    const baseName = "PhieuLuong_Alina_Thang_";
    const fileExtension = "zip";
    const month = params.thang;
    const fileName = generateFileNameZip(baseName, fileExtension, month);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("zip", "Error exporting Zip");
    }
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
    handleExportExcel(params);
  };

  const handleExportExcel = async (params) => {
    const url = "hanhchinhnhansu/bang-luong/export-excel";
    const baseName = "danh-sach-bang-luong";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Excel");
    }
  };

  const onClickExportChiLuong = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
    exportExcelChiLuong(params);
  };
  const exportExcelChiLuong = async (params) => {
    const url = "hanhchinhnhansu/bang-luong/danh-sach-chi-luong";
    const baseName = "danh-sach-chi-luong";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Excel");
    }
  };
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const excel = event.target.files[0];
      const formData = new FormData();
      formData.append("files", excel);
      setLoading(true);
      try {
        const response = await employeeService.uploadBangLuong(formData);
        if (response.data.code == 400) {
          Notification("error", response.data.message);
          setLoading(false);
        }else
        {
          Notification("success", "Import file excel lên thành công");
          setLoading(false);
          getList(params);
        }
      } catch (err) {
        Notification("error", "Lỗi khi import lên file excel");
        setLoading(false);
      }
    }
  };
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  useEffect(() => {
    dispatch(
      getPhongBanAPI({
        page: 1,
        limit: 100,
      })
    );
    dispatch(
      getApproveStatus({
        page: 1,
        limit: 100,
      })
    );
  }, []);
  useEffect(() => {
    setOptionsPBFields(employees.phongBanList, "phong");
  }, [employees.phongBanList]);

  useEffect(() => {
    if (ApproveStatusList.length) setOptionsApproveStatus(ApproveStatusList);
  }, [ApproveStatusList]);

  const setOptionsApproveStatus = (list) => {
    if (inputFieldsInit.find((field) => field.name === "trangThaiDuyet")) {
      inputFieldsInit.find((field) => field.name === "trangThaiDuyet").options =
        list?.map((item) => ({
          value: item.maTrangThai,
          label: item.tenTrangThai,
        }));
    }
  };

  const setOptionsPBFields = (list, tenPhongBan) => {
    if (inputFieldsInit.find((field) => field.name === tenPhongBan)) {
      inputFieldsInit.find((field) => field.name === tenPhongBan).options =
        list?.map((item) => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
    }
  };
  const handleSubmit = async () => {
    try {
      const payload = data
        .filter(
          (item: any) =>
            item.trangThaiDuyet === "00" || item.trangThaiDuyet === "01"
        )
        .map((item) => ({
          id: item.id,
          thuongLe: item.thuongLe,
          thuongChuyenCan: item.thuongChuyenCan,
          thuongDotXuat: item.thuongDotXuat,
          thuongHoaHong: item.thuongHoaHong,
          thuongLuongThang13: item.thuongLuongThang13,
          tienLuongNgungViec: item.tienLuongNgungViec,
          dieuChinhLuongThangTruoc: item.dieuChinhLuongThangTruoc,
          truyThuBH: item.truyThuBH,
          truTamUng: item.truTamUng,
          lyDo: item.lyDo,
          trangThaiDuyet: item.trangThaiDuyet,
        }));

      const res = await employeeService.updateBangLuong(
        payload,
        params.thang,
        params.nam
      );
      if (res.statusCode !== 200) {
        Notification("warning", res?.message || "Cập nhập thất bại");
      } else {
        Notification("success", "Cập nhập thành công ");
        getList(params);
      }
    } catch (res) {
      Notification("error", "Cập nhập thất bại");
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };
  const onKeyDownSearch = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  // Xác định độ dài của mảng columns
  const numberOfColumns = columns.length;

  // Thiết lập giá trị scroll dựa vào số lượng cột
  let scrollX;
  if (numberOfColumns <= 5) {
    scrollX = 1000;
  } else if (numberOfColumns <= 10) {
    scrollX = 1600;
  } else if (numberOfColumns <= 15) {
    scrollX = 2000;
  } else if (numberOfColumns <= 20) {
    scrollX = 3000;
  } else if (numberOfColumns <= 25) {
    scrollX = 4000;
  } else if (numberOfColumns <= 30) {
    scrollX = 5000;
  } else if (numberOfColumns <= 35) {
    scrollX = 6000;
  } else {
    scrollX = 7000;
  }

  allColumns.map((record) => {
    if (record.dataIndex == "thuongLe") {
      record.render = (value, record, index) => (
        <InputNumber
          disabled={disableField(record)}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongLe"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "thuongChuyenCan") {
      record.render = (value, record, index) => (
        <InputNumber
          disabled={disableField(record)}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongChuyenCan"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "thuongDotXuat") {
      record.render = (value, record, index) => (
        <InputNumber
          disabled={disableField(record)}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongDotXuat"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "thuongHoaHong") {
      record.render = (value, record, index) => (
        <InputNumber
          disabled={disableField(record)}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongHoaHong"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "thuongLuongThang13") {
      record.render = (value, record, index) => (
        <InputNumber
          disabled={disableField(record)}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["thuongLuongThang13"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "tienLuongNgungViec") {
      record.render = (value, record, index) => (
        <InputNumber
          disabled={disableField(record)}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["tienLuongNgungViec"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "dieuChinhLuongThangTruoc") {
      record.render = (value, record, index) => (
        <InputNumber
          disabled={disableField(record)}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["dieuChinhLuongThangTruoc"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "truyThuBH") {
      record.render = (value, record, index) => (
        <InputNumber
          disabled={disableField(record)}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["truyThuBH"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "truTamUng") {
      record.render = (value, record, index) => (
        <InputNumber
          disabled={disableField(record)}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          style={{ width: "100%" }}
          value={value}
          onChange={(value) => {
            const newData = [...data];
            newData[index]["truTamUng"] = value;
            setData(newData);
          }}
        />
      );
    }
    if (record.dataIndex == "lyDo") {
      record.render = (value, record, index) => {
        return (
          <Input
            disabled={disableField(record)}
            style={{ width: "100%" }}
            value={value}
            onChange={(e) => {
              const newData = [...data];
              newData[index]["lyDo"] = e?.target?.value;
              setData(newData);
            }}
          />
        );
      };
    }
    if (record.dataIndex == "trangThaiDuyet") {
      record.render = (value, record, index) => {
        return hasPermission(record) ? (
          <Select
            style={{ width: "100%" }}
            value={value}
            options={[
              { value: "00", label: "Lập bảng" },
              { value: "01", label: "Chờ duyệt" },
            ]}
            disabled={!isAdminHCNS()}
            onChange={async (val) => {
              const newData = [...data];
              newData[index]["trangThaiDuyet"] = val;
              setData(newData);
            }}
          />
        ) : (
          renderApproveStatus(value)
        );
      };
    }
  });

  const disableField = (record: any) => {
    return !hasPermission(record);
  };

  const hasPermission = (record: any) => {
    if (record.trangThaiDuyet === "00" || record.trangThaiDuyet === "01")
      return true;

    return false;
  };

  const renderApproveStatus = (status: string) => {
    return APPROVE_STATUS[status] || "Không có trạng thái";
  };

  return (
    <div className="recruitment-list" tabIndex={0}>
      <div className="recruitment-container">
        <div className="container" onKeyDown={onKeyDownSearch}>
          <ExpandSearchHCNS
            ref={expandRef}
            fields={inputFieldsInit}
            onClickSearch={onClickSearch}
            // Ẩn nút "Tìm kiếm nâng cao"
            isSearchExpend={false}
            isResetField={false}
          />
        </div>
        <div className="container" onKeyDown={onKeyDown}>
          <Space style={{ width: "100%" }} direction="vertical">
            {/*<Typography.Text strong>Danh sách nhân viên</Typography.Text>*/}
            {/*<Divider type="horizontal" style={{ margin: "0" }} />*/}
            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col>
                <Popover
                  trigger="click"
                  placement="topRight"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                      width={"600px"}
                      columnSizes={{ xs: 10, sm: 12, md: 8, lg: 8, xl: 8 }}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button
                    icon={<Icons.bars />}
                    className="btn-sub"
                    type="primary"
                  >
                    Cột hiển thị
                  </Button>
                </Popover>
              </Col>
              <Col>
                <Space
                  style={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    justifyContent: "start",
                  }}
                >
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUpload}
                    ref={fileInputRef}
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-sub"
                    type="primary"
                    onClick={handleClick}
                    style={{
                      width: "200px",
                      marginRight: "7px",
                    }}
                  >
                    Import lương thưởng
                  </Button>
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExport}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Xuất báo cáo</Typography>
                  </Button>
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickRoll}
                    icon={<ZipSVG />}
                  >
                    <Typography>Xuất phiếu lương</Typography>
                  </Button>
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExportChiLuong}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Danh sách chi lương</Typography>
                  </Button>
                  <Button
                    className="custom-btn"
                    type="primary"
                    onClick={() => {
                      setType("Request");
                      setRecord(null);
                      modalRef.current?.openModal();
                    }}
                    icon={<ExcelSVG />}
                  >
                    {" "}
                    Xuất Payment
                  </Button>
                  <Button
                    className="custom-btn"
                    type="primary"
                    htmlType="submit"
                    onClick={handleSubmit}
                    icon={<SaveWhiteIconSVG />}
                    disabled={isQuanLy() || isGiamDoc()}
                  >
                    Lưu lại
                  </Button>
                </Space>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                // rowSelection={{
                //   type: "radio",
                //   ...rowSelection,
                // }}
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employees.BangLuongTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    // onDoubleClick: e => handleView(record.id),
                  };
                }}
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{ x: scrollX }}
                size="middle"
              />
            )}
            <ModalCustom ref={modalRef} width={700} title={`Xuất ${type}`}>
              <PayMentRequest
                data={record}
                getListApi={getList}
                type={type}
                setCurrentPage={null}
                params={params}
              ></PayMentRequest>
            </ModalCustom>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ListPayroll;
